<template>
  <div>
      <table class="table table-hover" v-bind:id="id">
        <thead>
          <tr>
            <th>Campos</th>
            <th>Formulas</th>
            <th>Redondeo</th>
            <th>Tipo de redondeo</th>
            <th>&nbsp;</th>
          </tr> 
        </thead>
        <tbody> </tbody>
      </table>
    </div>
</template>
<script>
  export default {
    name:"TableSampleCostos",
    props: {id:'',data_:[],lengthMenu:[]},
    mounted () {
      this.createdTable();
      window.tableCalculo= this;
    },
    methods:{
      createdTable(){
          $('#'+this.id).DataTable({
            ordering: false,
            language: {
              emptyTable: "No se encontraron datos"
            },
            "data": this.data_,
            "columns": [
              {"data": "campo_nombre","title":"Campo"},
              {"data": "formula_texto","title":"Fórmula"},
              {"data": "redondeo","title":"Redondeo", "render": this.redondeo},
              {"data": "redondeo_nombre","title":"Tipo de redondeo"},
              {"render": this.btnDetalle ,"width":'15%'},   
            ]
          });
      },
      accionEditar(dato){
        this.$emit('accionEditar', dato);
      },
      accionEliminar(id,tramite,tipo){
        this.$emit('accionEliminar', id,tramite,tipo);
      },
      btnDetalle(data, type, row, meta){
        let btn= "<td class='text-center' width='15%'>"+
        "<a class='btn btn-icon-only btn-circle blue' href='#portlet-calculo' data-toggle='modal' title='Editar' onclick='"+"accionEditar("+row.id+")'><i class='fa fa-pencil'></i></a>"+
        "<a class='btn btn-icon-only btn-circle red' data-toggle='modal' href='#portlet-delete-calculo' title='Eliminar' onclick='accionEliminar("+row.id+")'><i class='fa fa-minus'></i></a>"+
        "</td>";
        return btn;
      },
      redondeo(data, type, row, meta){
        let check="&nbsp;&nbsp;&nbsp;<i class='icon-close font-red-sunglo'></i>";
        if(row.id_redondeo){
          check="&nbsp;&nbsp;&nbsp;<i class='icon-check font-green'></i>";
        }
        return check;
      }
    }        
  }
</script>
